import * as angular from "angular";
import {IController} from "angular";
import {ItinerariesTasksSettings} from "../../../agents/angular/models/itineraries-tasks-settings.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../models/task.model";
import {LocationType} from "../../../commons/types/location.type";

export class taskBundleItemCtrl implements IController {

  task: TaskModel;
  taskIndex: number;
  isSelected: boolean;
  isHighlighted: boolean;
  itinerariesTaskSettings: ItinerariesTasksSettings;

  public locationTypes: typeof LocationType = LocationType;

  onTaskSelectToggle: Function;
  private showBundleTaskList: any;
  private purposeToServiceType: any;
  private configZoneId: string;
  private bundledTaskList: any[];


  /* @ngInject */
  constructor(private $task, private tasksConstants, private splitService: SplitService, private $mdMedia) {
  }

  $onInit() {
    this.showBundleTaskList = false;
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;
    this.configZoneId = this.splitService.getTimeZone();
    if (this.task.bundledTaskList.length) {
      this.initBundledTaskList(angular.copy(this.task.bundledTaskList));
    }
  };

  onChangeStatus(task, status) {
    this.task = task;
  }

  private initBundledTaskList(bundledTaskList) {
    const pickupTasks = bundledTaskList.filter(t => t.taskSpec.purpose === 'Pickup');
    const dropoffTasks = bundledTaskList.filter(t => t.taskSpec.purpose === 'Dropoff');
    const operationTasks = bundledTaskList.filter(t => t.taskSpec.purpose === 'Operation');
    this.bundledTaskList = [].concat(pickupTasks, dropoffTasks, operationTasks);
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskBundleItem', {
    bindings: {
      task: '<',
      taskIndex: '<',
      isSelected: '<',
      isHighlighted: '<',
      itinerariesTaskSettings: '<',
      onTaskSelectToggle: '&'
    },
    template: require('./task-bundle-item.html').default,
    controller: taskBundleItemCtrl
  });
